'use strict';

const GalleryStore = require('../stores/GalleryStore');
const GalleryModalStore = require('../modal/GalleryModalStore');

function connectGalleryStoreToView(ConnectedBaseView) {
    const stores = ConnectedBaseView.prototype.stores || [];
    return ConnectedBaseView.extend({
        stores: stores.concat(GalleryStore),
    });
}

function connectGalleryModalStoreToView(ConnectedBaseView) {
    const stores = ConnectedBaseView.prototype.stores || [];
    return ConnectedBaseView.extend({
        stores: stores.concat(GalleryModalStore),
    });
}

module.exports = {
    connectGalleryStoreToView,
    connectGalleryModalStoreToView,
};



// WEBPACK FOOTER //
// ./assets/js/gallery/helpers/connectViewToStoresHelpers.es.js